module.exports = __webpack_public_path__ + "img/icon_none.569e108f.png";